/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuPublishResponse } from '../../models/menu-publish-response';
import { MenuPublishUpdateInput } from '../../models/menu-publish-update-input';

export interface MenusMenuIdPublishConfigsPut$Params {
  menuId: string;
  'Active-Tenant-Identifier': string;
      body: MenuPublishUpdateInput
}

export function menusMenuIdPublishConfigsPut(http: HttpClient, rootUrl: string, params: MenusMenuIdPublishConfigsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
  const rb = new RequestBuilder(rootUrl, menusMenuIdPublishConfigsPut.PATH, 'put');
  if (params) {
    rb.path('menuId', params.menuId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuPublishResponse>;
    })
  );
}

menusMenuIdPublishConfigsPut.PATH = '/menus/{menuId}/publish-configs';
